export default __webpack_public_path__ + "static/media/dummy-1.5be3d0d6.png";